export default{
  getSearchClassProStatus: (state) => state.searchClassProStatus,
  getSearchClassProSchool: (state) => state.searchClassProSchool,
  getSearchClassProLevel: (state) => state.searchClassProLevel,
  getSearchClassProFacult: (state) => state.searchClassProFacult,
  getSearchClassProUser: (state) => state.searchClassProUser,
}



// WEBPACK FOOTER //
// ./src/components/class-pros/store/getters.js